import { LifecycleStatusDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { LifecycleStatus } from '@/services/graphql/types';

export const mapperToLifecycleStatusDataEnum = createEnumMapperFunction(
  LifecycleStatus,
  LifecycleStatusDataEnum
);
